import type { ComboboxOption } from '@nesso/ui/primitives/combobox';

import { PLACE_OF_SERVICE_CODES, PLACE_OF_SERVICE_LABELS, US_STATES } from '@/entities/practice';

// Explains what the location name is for, shown next to the field it documents.
export const LOCATION_NAME_HELPER_TEXT =
    'Use the neighborhood, city, or street to make this location easy to distinguish from others';

export const DEFAULT_PLACE_OF_SERVICE_CODE = '11';

// Searchable by code or label, so "53" and "community" both find the same row.
export const PLACE_OF_SERVICE_OPTIONS: ComboboxOption[] = PLACE_OF_SERVICE_CODES.map((code) => ({
    value: code,
    label: `${code} – ${PLACE_OF_SERVICE_LABELS[code]}`,
    keywords: [code, PLACE_OF_SERVICE_LABELS[code]],
}));

// The state code is an alternate search term — it isn't a substring of most names.
export const STATE_OPTIONS: ComboboxOption[] = US_STATES.map(([code, name]) => ({
    value: name,
    label: name,
    keywords: [code],
}));
